import { render, staticRenderFns } from "./teamperformance.vue?vue&type=template&id=18b1ac5c&scoped=true&"
import script from "./teamperformance.vue?vue&type=script&lang=js&"
export * from "./teamperformance.vue?vue&type=script&lang=js&"
import style0 from "./teamperformance.vue?vue&type=style&index=0&id=18b1ac5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1ac5c",
  null
  
)

export default component.exports